var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE) ? _c('div', [_c('edit-beneficiary', {
    attrs: {
      "data-to-show": _vm.isPopupEditBeneficiaryDisplayed
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditBeneficiaryPopup(val);
      }
    }
  }), _vm._v(" "), _c('edit-beneficiary-rights', {
    attrs: {
      "data-to-show": _vm.isPopupEditRightsDisplayed
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditRightsPopup(val);
      }
    }
  }), _vm._v(" "), _c('edit-beneficiary-templates', {
    attrs: {
      "data-to-show": _vm.isPopupEditTemplatesDisplayed
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditTemplatesPopup(val);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex content-center items-center justify-between my-15 2xl:my-20 m-5 lg:mx-15 2xl:mx-20",
    on: {
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp
    }
  }, [_c('div', {
    staticClass: "flex flex-col lg:flex-row items-center justify-center lg:justify-between mt-5 w-full gap-y-4"
  }, [_c('div', {
    staticClass: "w-2/3 lg:w-1/3"
  }, [_c('search-bar', {
    attrs: {
      "name": "searchBeneficiary",
      "libelle": "",
      "value": _vm.search_beneficiary,
      "placeholder": "Rechercher un bénéficiaire",
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.search_beneficiary = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        _vm.changeSortType(sortType);
      }
    }
  })], 1)]), _vm._v(" "), _c('list-grid', {
    attrs: {
      "list-items": _vm.beneficiaries
    },
    scopedSlots: _vm._u([_vm.beneficiaries.length > 0 ? {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-1 xl:col-start-2 col-span-4 xl:col-span-3 ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n        Bénéficiaires\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 xl:col-span-3 text-center"
        }, [_vm._v("\n        Compte"), _c('span', {
          staticClass: "hidden xl:inline-block"
        }, [_vm._v(" bénéficiaire ")])]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n        Droits"), _c('span', {
          staticClass: "hidden xl:inline-block"
        }, [_vm._v("  d'accès")])]), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 mr-5 md:mr-10"
        }, [_vm._v("\n        Modèles"), _c('span', {
          staticClass: "hidden xl:inline-block"
        }, [_vm._v("  de pages ")])])];
      },
      proxy: true
    } : null, {
      key: "errorCases",
      fn: function () {
        return [_vm.beneficiaries.length === 0 ? _c('div', {
          staticClass: "flex flex-col justify-center items-center w-full"
        }, [_c('h3', {
          staticClass: "text-pink-600 w-full text-center font-semibold text-lg mt-12"
        }, [_vm._v("\n          Aucun bénéficiaire\n        ")]), _vm._v(" "), _c('h4', {
          staticClass: "text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
        }, [_vm._v("\n          Il n'y a aucun bénéficiaire trouvé\n        ")]), _vm._v(" "), _c('div', [_c('illustration', {
          attrs: {
            "name": "no_result"
          }
        })], 1)]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "hidden xl:inline-block col-span-1 ml-5"
        }, [_c('ProfilePicture', {
          attrs: {
            "size": "max-w-10 w-10 h-10",
            "other-object": item
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-4 xl:col-span-3 place-self-center justify-self-start text-lg text-grey-900 ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n        " + _vm._s(item.firstname) + "\n        "), _c('span', {
          staticClass: "uppercase"
        }, [_vm._v(_vm._s(item.lastname))])]), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 xl:col-span-3 place-self-center justify-self-center"
        }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_EDITER) ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-pink-300",
            "bg-color-square": "bg-pink-100",
            "icon-color": "text-pink-600",
            "libelle": "Compte bénéficiaire",
            "responsive": true,
            "icon": "edit"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.displayEditBeneficiaryPopup(item);
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 place-self-center justify-self-start"
        }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_DROITS) ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-teal-300",
            "bg-color-square": "bg-teal-100",
            "icon-color": "text-teal-600",
            "libelle": "Droits d'accès",
            "responsive": true,
            "icon": "layers"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.displayEditRightsPopup(item);
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE) ? _c('div', {
          staticClass: "col-span-3 place-self-center justify-self-start mr-5 md:mr-10"
        }, [_c('span', [_c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-indigo-300",
            "bg-color-square": "bg-indigo-200",
            "icon-color": "text-indigo-600",
            "libelle": "Modèles de pages",
            "responsive": true,
            "icon": "file-add"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.displayEditTemplatesPopup(item);
            }
          }
        })], 1)]) : _vm._e()];
      }
    }], null, true)
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }